<template>
  <div
    v-cdrag.self="{ parent: true, stopPropagation: true, axisy: true }"
    class="bookmark"
    :style="{ top: top * 100 + '%' }"
  >
    <div class="bookmark-bg"></div>
    <div class="can-drag-text-container">
      <p class="can-drag-text">{{ $t("general.canDragToMove") }}</p>
    </div>
    <div class="close-internal otz-icon" @click="close">F</div>
  </div>
</template>

<script>
import Icons from "@/components/Icons/Icons.vue";
export default {
  components: {
    Icons,
  },
  data() {
    return {};
  },
  props: ["top"],
  methods: {
    close() {
      this.$emit("closeBookmark");
    },
  },
};
</script>

<style scoped>
.bookmark {
  left: 0px;
  height: 70px;
  width: 100%;
  box-sizing: border-box;
  border: var(--custom-color1) solid 1px;
  border-right: none;
  border-left: none;
  z-index: 3;
}
.bookmark:hover {
  cursor: pointer;
  padding-bottom: 3px;
}
.bookmark-bg {
  background-color: var(--custom-color1);
  opacity: 0.25;
  height: 70px;
  width: 100%;
}
.bookmark:hover .bookmark-bg {
  background-color: var(--custom-color1);
  opacity: 0.3;
}
.can-drag-text-container {
  position: absolute;
  background-color: #00000014;
  padding: 0px 6px;
  border-radius: 4px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.5s ease, visibility 0.5s ease;
}
.bookmark:hover .can-drag-text-container {
  opacity: 1;
  visibility: visible;
}
.can-drag-text {
  margin: 0px;
  opacity: 1 !important;
  font-size: 12px;
  text-align: center;
}
.close-internal {
  display: flex;
  font-size: 11px;
  width: 52px;
  height: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
}
</style>
